import { TeamAPI } from './types'

export const teamApi: TeamAPI = ky => {
  return {
    async fetch() {
      return await ky('team/', {
        method: 'get'
      }).json()
    },

    async fetchStatus() {
      return await ky('team/status/', {
        method: 'get'
      }).json()
    },

    async fetchTeamMemberList({ patientId }) {
      return await ky(`team/${patientId}/`, {
        method: 'get'
      }).json()
    },

    async put({ patientId, params }) {
      return await ky(`team/${patientId}/`, {
        method: 'put',
        json: params
      }).json()
    },

    async patchTeamMember({ patientId, workerId, params }) {
      return await ky(`team/${patientId}/member/${workerId}/`, {
        method: 'patch',
        json: params
      }).json()
    },

    async deleteTeamMember({ patientId, workerId }) {
      await ky(`team/${patientId}/member/${workerId}/`, {
        method: 'delete'
      })
    }
  }
}
